import { createContext } from 'react';

export const StyleRulesSettingsTabContext = createContext({
  styleRules: [],
  styleRuleConfigurations: [],
  currentStyleRuleConfigurations: [],
  setCurrentStyleRuleConfigurations: () => {},
  selectedFolder: null,
  onSelectFolder: () => {},
  selectedUnitFilters: [],
  setSelectedUnitFilters: () => {},
  selectedActiveFilters: [],
  setSelectedActiveFilters: () => {},
  localSearchQuery: '',
  setLocalSearchQuery: () => {},
  onLocalSearchQueryChange: () => {},
  highlightedStyleRule: null,
  onSelectHighlightedStyleRule: () => {},
  getStyleRuleConfigurationsFolderItems: () => {},
});

export const StyleRulesSettingsTabProvider = StyleRulesSettingsTabContext.Provider;
